import { ThemeEvents } from '@theme/events';

class CartIcon extends HTMLElement {
  constructor() {
    super();
    this.cartCount = null;
    this.addToCartBehavior = null;

    this.clickHandler = this.handleClick.bind(this);
    this.cartUpdatedHandler = this.onCartUpdated.bind(this);
  }

  connectedCallback() {
    this.addToCartBehavior = this.dataset.addToCartBehavior || 'open_cart';

    this.cartCount = this.querySelector('[data-ref="cart-count"]');

    this.addEventListener('click', this.clickHandler);
    document.addEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdated, this.cartUpdatedHandler);
    this.removeEventListener('click', this.clickHandler);
  }

  getCurrentItemCount() {
    return parseInt(this.cartCount.textContent);
  }

  onCartUpdated(event) {
    const { itemCount, source, sections } = event.detail.data;

    if (typeof itemCount === 'number') {
      this.#setCount(itemCount);
    }

    if (this.addToCartBehavior === 'open_cart' && source !== 'cart-reservation-timer') {
      this.openCart();
    }

    // Toujours recompter depuis le DOM du drawer : les compteurs transmis sont
    // bruts (un coffret composé doit compter pour 1, pas pour ses N lignes).
    // Délai plus long quand des sections re-rendent le drawer.
    setTimeout(
      () => {
        this.ensureCartCountIsCorrect();
      },
      sections ? 350 : 100,
    );
  }

  #setCount(count) {
    if (!this.cartCount) return;
    this.cartCount.textContent = count;
  }

  // Cette fonction est utile pour les applications de gift ou autre qui viennent modifier le panier pendant sa mise à jour. Ca permet de s'assurer que le compteur est correct.
  ensureCartCountIsCorrect() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (!cartDrawer) return;

    let cartCount = 0;

    const cartItems = cartDrawer.querySelectorAll('[data-ref="cart-item"]');
    cartItems.forEach((cartItem) => {
      const input = cartItem.querySelector('[data-ref="quantity-selector-input"]');
      const quantity = parseInt(input?.value ?? cartItem.dataset.quantity ?? '0', 10);
      cartCount += Number.isNaN(quantity) ? 0 : quantity;
    });

    const nestedChildren = cartDrawer.querySelectorAll('[data-ref="cart-line-child"][data-quantity]');
    nestedChildren.forEach((child) => {
      const quantity = parseInt(child.dataset.quantity ?? '0', 10);
      cartCount += Number.isNaN(quantity) ? 0 : quantity;
    });

    // Chaque coffret composé (carte regroupée) compte pour un seul article
    cartCount += cartDrawer.querySelectorAll('[data-ref="coffret-group"]').length;

    if (cartCount != this.getCurrentItemCount()) {
      this.cartCount.textContent = cartCount;
    }
  }

  handleClick() {
    this.openCart();
  }

  openCart() {
    const cartDrawer = document.querySelector('[data-ref="cart-drawer"]');
    if (cartDrawer) {
      cartDrawer.open();
    } else {
      window.location.href = Theme.routes.cart_url;
    }
  }
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}
